const getters = {
  lang: state => state.settings.lang,
  token: state => state.user.token,
  user: state => state.user.user,
}
export default getters
